import { Collapse, CollapseProps } from '@mantine/core';

export type ICollapseProps = CollapseProps;

export function ZorroCollapse({ ...props }: ICollapseProps) {
  return <Collapse {...props} />;
}
